import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Patient } from '../patients/patient';
import { PatientsService } from '../patients.service';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommerrorService } from '../commerror.service';
import { PregnancyService } from '../pregnancy.service';
import { GastroFormsService } from '../gastro-forms.service';
import { DiagnosisService } from '../diagnosis.service';
import { CalendarService } from '../calendar.service';
import { SignatureService } from '../signature.service';
import { Exam } from '../interfaces/exams.service/types';
import { PathologyService } from '../pathology.service';

@Component({
    selector: 'app-patexams',
    templateUrl: './patexams.component.html',
    styleUrls: ['./patexams.component.scss'],
    standalone: false
})
export class PatexamsComponent implements OnInit, OnDestroy {
  @ViewChild('inputTitle')
  set inputTitle(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus()
    }
  }
  inform = false;
  showComment = false;
  selectedForm;
  calendarForm: boolean = false;
  pat: Patient;
  showPat: boolean = false;
  pregnancies: any = null;
  etype: string = "OB STD";
  typeForm = false;
  examname: string;
  concentForm;
  otherExams: any;
  formsExams: any[] = [];
  calendarForms: any[] = []
  notFormExams: any[] = [];
  ecgExams: any[] = [];
  gastroForms: any[] = [];
  gastroVisits: any[] = [];
  gastroExams: any[] = [];
  patInbox: any[] = [];
  letters: any;
  showLogin = false;
  AWLAlreadyExists = false;
  private destroy$ = new Subject();
  public examsLoaded$ = new Subject();
  toDelete;
  readydelete = false;
  goEx;
  newExam = true;
  closePreg: number = null;
  pregExams;
  defaults;
  startClinic: number;
  openAWL = false;
  subscription = new Subscription()
  FORMS = ['Consultation Letter', 'Inform Consent'];
  ECG = ['Resting ECG', 'Ergometry', 'Holter ECG'];
  CARDIO = ['TTE Adults','Duplex Carotid', 'Stress', 'Stress-Echo'];
  GASTRO = ['Colonoscopy', 'Gastroscopy', 'Sigmoidoscopy', 'Abdomen US', 'Hemorrhoids Treatment'];
  INVASIVE = ['Amniocentesis', 'CVS'];
  formMissing=false
  mustHaveFormAdmission=['Colonoscopy', 'Gastroscopy', 'Sigmoidoscopy']
  showPrintPopup=false
  examIdSelectedPrintForm=null

  GastroForms = ['Admission Form', 'Time Out Form','Recovery Form','Release Form'];
  gastroExamsChanged = new Subject()
  currentSignatureUrl = null;
  signatureUploadStatus = '';
  signatureLoading = false;
  fanciness = 'simple';
  save: boolean = false;
  labReportID: number = null;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patientQuestionnaires: any[] = [];

  private examUnSignedSub: Subscription;

  constructor(
    public ce: CommerrorService,
    public gfs: GastroFormsService,
    public patService: PatientsService,
    public ps: PregnancyService,
    public examService: ExamsService,
    public login: LoginService,
    public ds: DiagnosisService,
    public cf: CalendarService,
    public signatureService: SignatureService,
    private pathologyService: PathologyService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {}

  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data + '/' + this.pat.PID;
    });
  }

  ngOnInit() {
    this.login.loginMissing();
    try {
      this.pat = this.patService.getPat();
      //this.pat.asignVals(history.state.data);
    }
    catch { }
    
    if (this.login.isGastro)
      this.etype = "Gastro";
    if(this.login.userType=='nurse'){
      this.etype='GastroForms'
    }
    if(this.login.category.name == 'forms')
      this.etype = 'Forms'
    if (this.pat.ID != "default") {
      this.resetPregs();
    }
    else {//defaults
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      },
        (error) => {
          console.error(error);
        });
      this.loadCurrentSignature();
    }
    this.subscription = this.patService.lettersChange.subscribe(
      (response) => {
        this.letters = response;
      }
    )
    this.subscription =this.cf.caldeleted$.subscribe((data) => {
        this.resetPregs();
    })
    if(! this.login.isCardio && this.pat.ID === 'default')
      this.examService.getCustomTitles();
    this.getLabInbox();
    this.loadPatientQuestionnaires();
  }

  loadPatientQuestionnaires() {
    if (!(this.login.premissions && this.login.premissions['Questionnaires'])) return;
    if (!this.pat || this.pat.ID === 'default' || this.pat.PID == null) return;
    this.examService.getPatientQuestionnaires(this.pat.PID).subscribe(
      (data: any) => {
        this.patientQuestionnaires = (data && data.items) || [];
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openQuestionnairePdf(item: any) {
    if (item && item.answeredDate && item.code) {
      window.open('api/questionnaires/pdf/' + item.code);
    }
  }

  resetPregs(){
    this.examService.getExams(this.pat.PID.toString()).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.pregnancies = data["pregnancies"];
      this.examService.pregnancies = data["pregnancies"];
      for(let item of this.pregnancies){
        this.examService.getAllCalForms(item.AutoIndex).pipe(takeUntil(this.destroy$)).subscribe((data) => {
          if(data[0].calendar.length > 0)
            item.calendarForms.push(data[0].calendar[0])
          if(data[0].concent.length > 0)
            item.forms = data[0].concent
            // for(let concentForm of data[0].concent)
            // item.forms.push(concentForm)

        });
        // this.examServe.getConcentForms(item.AutoIndex).subscribe((data) => {
        //   if(data[0])
        //     item.forms.push(data[0])
        // })
      }
      
      if (this.pregnancies && this.pregnancies.length > 0 && this.pregnancies[0].LMP)
        this.pat.LMP = this.pregnancies[0].LMP
      // this.letters = this.patService.getConsultationLetter(this.pat);
      this.otherExams = data["other"];
      if (this.otherExams.length > 0) {
        this.otherExams.forEach((exam) => {
          if (this.FORMS.includes(exam.ExamType)) {
            this.formsExams.push(exam)
          } else {
            if (this.ECG.includes(exam.ExamType))
              this.ecgExams.push(exam)
            else if (this.GASTRO.includes(exam.ExamType)) {
              this.gastroExams.push(exam)
            }
            else
              this.notFormExams.push(exam)
          }
        })
      }
      if(this.login.isGastro){
        this.examsLoaded$.next(undefined);
        this.ds.BuildList
      }
      if (this.pat.AWLID) {
        if (!this.login.isGastro) {
          for (let i = 0; i < this.pregnancies.length; i++) {
            for (let e of this.pregnancies[i]['exams']) {
              if (e.AWLID == this.pat.AWLID) {
                this.AWLAlreadyExists = true;
                return;
              }
            }
          }
        }
        for (let e of this.otherExams) {
          if (e.AWLID == this.pat.AWLID) {
            this.AWLAlreadyExists = true;
            return;
          }
        }
      }else{
        if(this.login.isCardio){
          this.patService.getPatAWL()
          
        }
      }
    },
      (error) => {//add this later
        console.error(error);
      });
    this.subscription = this.examsLoaded$.subscribe(() => {
      var v = this.gfs.getVisits(this.pat.PID);
      v.subscribe((data: any) => {
        this.gastroVisits = data;
        this.gastroVisits.forEach((visit, i) => {
          this.gastroVisits[i]['exams'] = this.gastroExams.filter((exam) => {
            return exam.CreationTime.split('T')[0] == visit.ExamDate.split('T')[0]
          })
          var f = this.gfs.getFormByVisit(visit.AutoIndex);
          f.subscribe((data) => {
            this.gastroVisits[i]['forms'] = data
          })
        })

        this.save = false;
        if(this.examname === 'Admission Form' || this.examname=='Recovery Form' || this.examname === 'Time Out Form' || this.examname==='Release Form' || this.examname==='Course Of Exam') {
          this.save = true;
        }
        this.gfs.awlIndex=this.gastroVisits[0]['AutoIndex']
        try{this.gfs.loadForm(false, true, this.gastroVisits[0]['AutoIndex'], this.save,this.examname)}
        catch{}
        
      })
    })
    this.login.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      /*if(this.login.ClinicID && this.login.ClinicID != this.startClinic){
        //trying to switch clinics on opening exams
        this.showLogin=false;
        this.cErr.Error = "Clinic Not Autorized on this patient";
        this.cErr.ErrorType = "Clinic Switched on Login";
        return;
      }*/
      if (this.goEx) {
        this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
      else{
        if (this.etype == 'GastroForms' || this.examname =='Inform Consent' || this.concentForm) {
          this.showLogin = false;


          if(this.etype == 'GastroForms'){
            this.typeForm = true;
            this.inform=false;
            var awl = this.pat.AWLID ? this.pat.AWLID.toString() : this.gastroVisits[0].AutoIndex.toString();
            this.examsLoaded$.next(undefined);
          }
          if(this.examname =='Inform Consent' || this.concentForm)
            this.inform=true;
        } else {
          if(this.pregnancies.length > 0 && this.pregnancies[0].forms.filter((i) => i.ExamType == this.examname && !i.ExamID).length == 0 && !this.login.ishospital  && this.login.premissions.Consent ){
            this.inform = true;
            this.showLogin = false;
            this.examService.openNewExam = true;
          }else{
            if(this.pregnancies.length > 0)
              this.examService.concentForm = this.pregnancies[0].forms.filter((i) => i.ExamType == this.examname && !i.ExamID)[0]
            this.examService.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP);
          }
        }
      }
    });
  }

  viewonly() {
    this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }
  startForm(form = null) {
    if( this.examname=='Inform Consent' || form){
      this.examService.examID = null;
      this.concentForm = form;
      this.showLogin = true;
      this.examService.openNewExam = false;
    }else{
      this.concentForm = null;
      this.inform = false;
      var today = new Date().toISOString().split('T')[0];
      var checkAwl = true;
      if(this.gastroVisits.length > 0){
        checkAwl = new Date(this.gastroVisits[0].ExamDate.split("T")[0]).toISOString().split("T")[0] !== today
      }
      if(this.GastroForms.includes(this.examname) && checkAwl){
        return this.ce.errorGastro("Today List Missing", 'A TodayList has to be generated before a new exam can be opened!')
      }
      this.showLogin = true;
      return;
    }
  }
  goForm(form) {

    this.typeForm = true;
    var isTimeOut = form['FormName'] =='Time Out Form';
    this.gfs.awlIndex=form['AWLID']
    this.gfs.loadForm(isTimeOut,form,undefined,undefined,form['FormName'])
  }

  startExam(ignoreCheckFormExist=false) {
    if (this.examname === 'Send Questionnaire') { this.openSendQuestionnaireForPatient(); return; }
    var today = new Date().toISOString().split('T')[0];
    this.examService.examID = null;
    var checkAwl = true;
    if(this.gastroVisits.length > 0){
      checkAwl = new Date(this.gastroVisits[0].ExamDate.split("T")[0]).toISOString().split("T")[0] !== today
    }

    if(this.GASTRO.includes(this.examname) && checkAwl && this.pat.ID !='default'){
      return this.ce.errorGastro("Today List Missing", 'A TodayList has to be generated before a new exam can be opened!')
    }
   let v = this.gfs.getVisits(this.pat.PID);
v.subscribe((data: any) => {
  if(this.GASTRO.includes(this.examname)){
    if(!data[0].ExamCode){
      return this.ce.errorGastro("Today List Missing", 'Must select exam type in Today List')
    }
    const examCode=data[0].ExamCode.split('-')
    let foundMatch = false;
    for (const code of examCode) {
      if (this.examname.includes(code)) {
        foundMatch = true;
        break; // Break if a match is found
      }
    }
    if(!foundMatch){
      let examsFromTodayList=examCode[0]
      if(examCode.length>1) examsFromTodayList=`${examCode[0]} or ${examCode[1]}`
      return this.ce.errorGastro("Today List", `Today List only allows ${examsFromTodayList} `)

    }
  }



  this.formMissing=false
  const lastVisitForm=this.gastroVisits[0].forms[0];
  const formCreationTime=lastVisitForm ?new Date(lastVisitForm?.CreationTime.split("T")[0]).toISOString().split("T")[0]:null
 if (this.gastroVisits.length > 0 &&  (!lastVisitForm || formCreationTime !== today) && this.mustHaveFormAdmission.includes(this.examname) && !ignoreCheckFormExist){
  return this.formMissing=true
 }
  if (!this.etype || !this.examname)
    return;
  if (this.pat.ID != "default") {
    this.concentForm = null;
    this.newExam = true;
    this.showLogin = true;
    return;
    // this.examServe.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP);
  }
  else {//default
    if (this.defaults[this.examname]) {
      this.examService.goExam(null, this.defaults[this.examname], this.examname);
    }
    else
      this.examService.startExam(this.examname, 0, "default");
  }
  });



    
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.examUnSignedSub) {
      this.examUnSignedSub.unsubscribe();
    }
    this.gfs.awlIndex=null
  }

  canOpen(): boolean {
    return this.login.canStartExam(this.pat.AWLID != null) && (!this.AWLAlreadyExists || this.login.AWLUnlimited) && (! this.login.separatedClinic || this.login.isAdmin || ! this.patService.getPat().UID || this.patService.getPat().UID == this.login.UID || this.patService.getPat()['AWLUID'] == this.login.UID);
  }

  goExam(pregid: number, exam, examtype: string, examtime: string) {
    this.examService.examObject = exam; // Reassign the exam object again.

    // For login for Edit, reassign new un-singed exam to the goEx:
    this.examUnSignedSub = this.signatureService.examUnSigned$.subscribe((data: Exam) => {
      this.goEx = { preg: pregid, exam: data, etype: examtype };
    });

    const canOpenExam = (userType: string): boolean => {
      return (
        userType === "doctor" ||
        userType === "visitingdoc" ||
        userType === "tech" ||
        userType === "nurse"
      );
    };

    if ((exam.Locked && exam.LockedBy.toLowerCase() != this.login.loginname.toLowerCase()) || ! this.canView(exam)){
      return;
    }
    
    let etime = new Date(examtime);
    var closed;
    if(exam.ClosedDate)
      closed = new Date(exam.ClosedDate);
    let now = new Date();
  
    if (examtype !== "Emergency Room" && ((!this.signatureService.isExamSigned(exam))) && canOpenExam(this.login.userType)) {
      this.newExam = false;
      this.showLogin = true;
      this.goEx = { preg: pregid, exam: exam, etype: examtype };
      if (this.login.ClinicID) {
        this.startClinic = this.login.ClinicID;
      }
    } else {
      if (canOpenExam(this.login.userType)) {
        this.newExam = false;
        this.showLogin = true;
        this.examService.examID = exam.AutoIndex;
        this.goEx = { preg: pregid, exam: exam, etype: examtype };
      } else {
        this.examService.goExam(pregid, exam, examtype,true);
      }
    }
  }

  canView(exam){
    return ! this.login.separatedClinic || this.login.isAdmin || this.login.userType == 'secretary' ||  this.login.userType === 'nurse' || exam.UID == this.login.doctor;
  }

  askDelete(exam) {
    if (this.defaults || this.signatureService.canDeleteExam(exam)) {
      this.toDelete = exam;
    }
    return false;
  }

  deleteExam() {
    this.pat.AWLID = this.toDelete.AWLID;
    this.examService.deleteExam(this.toDelete.AutoIndex, this.toDelete.AWLID);
    if (!this.defaults) {
      for (let i = 0; i < this.pregnancies.length; i++) {
        for (let j = 0; j < this.pregnancies[i]['exams'].length; j++) {
          if (this.pregnancies[i]['exams'][j].AutoIndex == this.toDelete.AutoIndex) {
            this.pregnancies[i]['exams'].splice(j, 1);
            break;
          }
        }
      }
      for (let i = 0; i < this.otherExams.length; i++) {
        if (this.otherExams[i].AutoIndex == this.toDelete.AutoIndex) {
          this.otherExams.splice(i, 1);
          break;
        }
      }
    }
    else {
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      }, (error) => {
        console.error(error);
      })
    }
    this.toDelete = null;
    this.readydelete = false;
  }

  showClose(pregid: number) {

  }
  closCalForm(event){
    if(event == '2' || this.examService.openNewExam){
      this.examService.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP, this.examService.concentForm);
    }
    this.examService.openNewExam = false;
    this.calendarForm = false;
    this.inform=false;
    if (this.pat.ID != "default") {
      this.resetPregs();
    }
    else {//defaults
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      },
        (error) => {
          console.error(error);
        });
    }
  }

  deleteDefault(ex: string) {
    if (this.defaults[ex]) {
      this.askDelete(this.defaults[ex])
    }
  }

  getDiagnosis(exam, show = false){
    var strDiagnosis ='No relevant data';
    if(exam && exam.DiagnosisCodes){
      var temp =this.ds.BuildList(exam.DiagnosisCodes);
      if(temp.length > 0){
        strDiagnosis = '';
        for(let i=0;i<temp.length;i++){
          strDiagnosis +=temp[i][1].split('>')[temp[i][1].split('>').length -1 ]
          if(temp.length >1 && i < temp.length -1)
            strDiagnosis += ","
        }
      }
    }else if(exam && exam.Anomalies && exam.Anomalies !='')
      strDiagnosis = exam.Anomalies
    if(show && exam['Anomalies'] && exam.Anomalies.length >15)
      // return 'Read More'
      return exam.Anomalies.split(" ")[0] + "...";
    else
      return strDiagnosis;
    
  }
  loadCalendarForm(form){
    this.calendarForm = true;
    this.selectedForm = form;
  }

  getConcent(exam){
    var temp = this.examService.pregnancies.filter((i) => i.AutoIndex == exam.PregIndex)
    if(temp.length > 0){
      temp = temp[0].forms.filter((i) => i.ExamID == exam.AutoIndex)
    } 
    if(temp.length>0)
      return temp[0];
    else
      return false;

  }

  pregClosed(){
    for(let p of this.pregnancies){
      if(p.AutoIndex == this.closePreg)
        p.ClosedDate = new Date();
    }
    this.closePreg=null;
  }
  togglePrintPopup(examId=null) {
    this.examIdSelectedPrintForm=examId
    this.showPrintPopup = !this.showPrintPopup;
  }

   printPathologyForm(examId) {
    let printUrl: string;
    let autoIndex;

    if (examId) {
      autoIndex =  examId
      printUrl = `api/gastro/pathologyFormPrint/${autoIndex}`;
      window.open(printUrl);
    } 
    return

  }

  existFormForTodayLastVisit(formName) {
    let existForm = false

    if (!this.gastroVisits || !this.gastroVisits[0] || !this.gastroVisits[0]['forms'] || !this.gastroVisits[0]['forms'].length) return existForm

    const providedDate = new Date(this.gastroVisits[0].ExamDate);

    // Get the current date
    const currentDate = new Date();

    // Check if the provided date is today
    const isToday = (
      providedDate.getDate() === currentDate.getDate() &&
      providedDate.getMonth() === currentDate.getMonth() &&
      providedDate.getFullYear() === currentDate.getFullYear()
    );
    if (!isToday) return existForm;
    this.gastroVisits[0]['forms'].forEach(form => {
      if (form.FormName == formName) {
        existForm = true
      }
    });
    return existForm
  }

  getBacColor(formName: string): string {
    return this.existFormForTodayLastVisit(formName) ? '#277382' : '#e5eef0';
  }

  getStyle(formName:string){
   const backGround={'background-color': this.getBacColor(formName)}
   const fontColor={'color':this.getFontColor(formName)}
   return {...backGround,...fontColor}

  }

  getFontColor(formName: string){
    return this.existFormForTodayLastVisit(formName) ? '#FFFFFF' : '#015a6c';
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: triggered from Create-New > Letters and Certificates > Send
  // Questionnaire. No ExamType is passed, so the popup preselects nothing
  // and the user picks which questionnaire to send.
  onSendQuestionnaireClosed() {
    this.showSendQuestionnaire = false;
    if (this.pat && this.pat.PID != null) { this.resetPregs(); this.loadPatientQuestionnaires(); }
  }

  openSendQuestionnaireForPatient() {
    this.openSendQuestionnaire({
      Mobile: this.pat ? this.pat.Mobile : null,
      ID: this.pat ? this.pat.ID : null,
      PID: this.pat ? this.pat.PID : null,
    });
  }

  getLabInbox(){
    this.pathologyService.getLabReports(false).subscribe((data: any[]) => {
      this.patInbox = data;
    });
  }

  loadCurrentSignature() {
    this.signatureLoading = true;
    this.signatureService.checkSignatureExists(this.login.ClinicID, this.login.UID).subscribe(
      (blob) => {
        this.signatureLoading = false;
        if (blob && blob.size > 0) {
          this.currentSignatureUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
        } else {
          this.currentSignatureUrl = null;
        }
      },
      () => {
        this.signatureLoading = false;
        this.currentSignatureUrl = null;
      }
    );
  }

  deleteSignature() {
    this.signatureLoading = true;
    this.signatureService.deleteSignature().subscribe(
      () => {
        this.currentSignatureUrl = null;
        this.signatureLoading = false;
        this.signatureUploadStatus = '';
      },
      (error) => {
        this.signatureLoading = false;
        console.error(error);
      }
    );
  }

  onSignatureFileSelected(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.signatureUploadStatus = '';
    this.signatureLoading = true;
    this.signatureService.uploadSignature(file).subscribe(
      () => {
        this.signatureUploadStatus = 'Signature uploaded successfully';
        this.loadCurrentSignature();
      },
      (error) => {
        this.signatureLoading = false;
        this.signatureUploadStatus = 'Upload failed';
        console.error(error);
      }
    );
    event.target.value = '';
  }

}
